/**
 * Created by liuyong on 2021/3/19
 */
// svg 入口文件
import Vue from 'vue'
// svg 组件
import SvgIcon from '@/components/SvgIcon.vue'

// 全局注册
Vue.component('svg-icon', SvgIcon)

// 引入 svg 文件
const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/)
requireAll(req)
